var login = {
    welcome: "WELCOME",
    text1: "Sign in - All fields are required",
    text2: "Enter your Email and Password:",
    updateNoticeTitle: "We've renewed the platform",
    updateNoticeText: "We've updated the platform with some improvements. To keep enjoying it, you'll just need to set up a new password before signing in again — it only takes a minute.",
    updateNoticeAction: "Please click on \"Forgot Password?\", enter your email address, and follow the instructions you receive to create a new password.",
    email: "Email:",
    password: "Password:",
    keep: "Keep me signed in",
    loginbtn: "Login",
    link1: "Register",
    link2: "Forgot Password?"
}
module.exports = login

